// kontakt/index.jsx

import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
  InputAdornment,
  Grid,
  FormHelperText,
  Paper
} from '@mui/material';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';

const BestaetigungPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:999px)');

  return (
    <Box>
      <Navbar />

      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? 2 : 4,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: isMobile ? 3 : 4,
            maxWidth: 600,
            width: '100%',
            textAlign: 'center',
            backgroundColor: '#ffffff',
          }}
        >
          <Typography
            variant={isMobile ? 'h5' : 'h4'}
            component="h1"
            sx={{
              marginBottom: 2,
              color: theme.palette.text.primary,
              fontWeight: 500,
            }}
          >
            E-Mail bestätigt!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              lineHeight: 1.6,
            }}
          >
            Deine E-Mail-Adresse wurde erfolgreich bestätigt.
          </Typography>
        </Paper>
      </Box>
      
      <Footer />
    </Box>
  );
};

export default BestaetigungPage;